export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CREATE_USER = "CREATE_USER";
export const GET_USER = "GET_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
